import { render, staticRenderFns } from "./BlockLocation.vue?vue&type=template&id=6300b0fc"
import script from "./BlockLocation.vue?vue&type=script&lang=js"
export * from "./BlockLocation.vue?vue&type=script&lang=js"
import style0 from "./BlockLocation.vue?vue&type=style&index=0&id=6300b0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports